export const OPEN = 'confirm-hierarchy-updates-modal/OPEN';
export const CLOSE = 'confirm-hierarchy-updates-modal/CLOSE';
